export const TOOL_CALL_FRIENDLY_NAMES: Record<string, string> = {
  get_workflow: "Looking at the plan",
  get_node_catalog: "Checking my tools",
  get_node_detail: "Reading the instructions",
  get_brand_config: "Loading the brand",
  get_session_info: "Checking task status",
  get_execution_status: "Checking progress",
  get_session_assets: "Looking at files",
  update_node_config: "Updating the plan",
  add_node: "Adding a new step",
  remove_node: "Removing a step",
  reorder_nodes: "Reorganizing steps",
  reset_workflow: "Starting fresh",
  update_session_brief: "Updating the brief",
  run_pipeline: "Starting the engine",
  run_node: "Working on a step",
  start_coagent_research: "Starting research",
  start_social_research: "Starting social research",
  get_social_data: "Reading social data",
  start_brand_research: "Starting brand research",
  update_brand_field: "Updating brand config",
  regenerate_color_palette: "Regenerating colors",
  generate_brand_logos: "Generating logos",
  select_brand_logo: "Selecting logo",
  generate_brand_icon_manifest: "Building icon manifest",
  update_brand_icon_manifest: "Updating icon manifest",
  generate_brand_icons: "Generating brand icons",
  generate_brand_backgrounds: "Generating backgrounds",
  generate_brand_assets: "Generating asset bundle",
  save_brand: "Saving brand",
  get_brand_data: "Loading brand data",
  get_video_brief: "Loading video brief",
  send_to_production: "Sending to production",
  start_growth_research: "Starting growth analysis",
  start_geo_research: "Starting GEO audit",
  present_gap_analysis: "Analyzing gaps",
  generate_schemas: "Generating JSON-LD",
  generate_copy_upgrades: "Rewriting content",
  generate_entity_payload: "Building entity kit",
  get_geo_data: "Reading GEO data",
  render_google_auth: "Opening Google auth",
  propose_tracking_plan: "Building tracking plan",
  provision_tracking: "Provisioning tracking",
  generate_campaign_assets: "Generating campaigns",
  push_campaigns: "Pushing campaigns",
  run_coagent_step: "Processing step",
  get_campaign_data: "Reading campaign data",
  get_wizard_status: "Checking progress",
  advance_step: "Moving to next step",
  set_step: "Jumping to step",
  update_campaign_data: "Updating campaign",

  // ── Maestro orchestrator tools ──────────────────────────────────────────
  // Tier 0: Read tools
  get_org_context: "Reading organization overview",
  list_sessions: "Browsing sessions",
  get_session_detail: "Opening session details",
  list_artifacts: "Browsing artifacts",
  list_team_members: "Listing team members",
  list_brands: "Listing brands",
  list_workspaces: "Listing workspaces",
  list_workflows: "Checking available workflows",

  // Tier 1: Extended read tools
  get_full_artifact: "Reading full artifact",
  get_session_tasks: "Checking session tasks",
  get_session_chat_history: "Reading chat history",
  list_integrations: "Checking integrations",
  get_credit_usage: "Checking credit usage",
  get_pipeline_execution_status: "Checking pipeline progress",
  list_generation_logs: "Browsing generation history",
  get_google_ads_status: "Checking Google Ads status",
  list_ecommerce_products: "Loading products",
  get_content_studio_sources: "Checking content sources",

  // Tier 2: Delegation tools
  delegate_to_remi: "Delegating to Remi",
  delegate_to_operator: "Delegating to Marcus",
  delegate_to_cipher: "Delegating to Skylar",
  delegate_to_nova: "Delegating to Content Studio",
  open_department_team_workspace: "Opening workspace",
  start_new_session: "Creating new session",
  open_session: "Opening session",

  // Tier 3: Action tools
  run_brand_research: "Running brand research",
  run_social_research: "Running social research",
  run_growth_research: "Running growth analysis",
  run_ecommerce_research: "Running ecommerce research",
  run_geo_research: "Running GEO audit",
  execute_coagent_step: "Executing agent step",
  save_brand_profile: "Saving brand profile",
  generate_ad_creative: "Generating ad creative",
  generate_social_video: "Generating social video",
  list_ads_templates: "Loading ads templates",
  generate_ads_image: "Generating ads image",
  generate_ads_video_scripts: "Generating video scripts",
  list_ads_video_personas: "Loading video personas",
  generate_ads_video: "Generating ads video",
  create_workspace: "Creating workspace",
  save_artifact: "Saving artifact",
  start_execution: "Starting execution",
  cancel_execution: "Cancelling execution",

  // Tier 4: Platform tools
  deploy_google_ads: "Deploying to Google Ads",
  list_growth_accounts: "Listing growth accounts",
  get_ecommerce_metrics: "Loading ecommerce metrics",
  update_product_metric: "Updating product metric",
  bulk_update_product_metric: "Bulk updating product metrics",
  plan_ecommerce_campaigns: "Planning campaigns",
  get_shopify_store: "Checking Shopify store",
  run_content_intelligence: "Analyzing content performance",
  content_studio_add_source: "Adding content source",
  content_studio_run_article_pipeline: "Running article pipeline",
  content_studio_scan_sources: "Scanning for sources",
  content_studio_list_articles: "Querying articles",
  content_studio_list_sources: "Querying sources",
  content_studio_list_flows: "Querying flows",
  content_studio_unread_counts: "Checking unread counts",
  content_studio_source_options: "Loading source options",
  content_studio_fetch_sources: "Fetching sources",
  content_studio_run_article: "Running article pipeline",
  content_studio_skip_article: "Skipping article",
  content_studio_retry_article: "Retrying article",
  content_studio_bulk_action: "Applying bulk action",
  content_studio_quick_add: "Adding article by URL",
  content_studio_bulk_run: "Processing articles",
  content_studio_delete_source: "Deleting source",
  content_studio_switch_tab: "Switching tab",
  content_studio_filter_articles: "Filtering articles",
  content_studio_show_article: "Showing article",
  content_studio_show_source: "Showing source",
  content_studio_highlight: "Highlighting element",
  start_event_capture: "Starting event capture",
  analyze_events: "Analyzing website events",

  // Tier 5: Utility tools
  check_task_status: "Checking task status",
  get_video_library: "Browsing video library",
  generate_video_preview: "Generating video preview",
  field_assist: "Suggesting field value",
  delete_session: "Deleting session",
  update_session: "Updating session",
  recover_stuck_sessions: "Recovering stuck sessions",
  generate_ugc_scripts: "Generating UGC scripts",
  generate_template_preview: "Generating template preview",
  list_video_templates: "Loading video templates",
  list_generated_videos: "Loading generated videos",
  generate_geo_implementation: "Creating implementation plan",
  generate_implementation_plan: "Creating implementation plan",
  highlight_widget: "Highlighting next action",
  ads_update_modal_field: "Updating ad fields",
  ads_navigate: "Navigating workspace",
  ads_add_product: "Adding product",
  ads_highlight: "Highlighting workspace section",

  // ── Ads (Marcus) research, planning, and dispatch tools ────────────────
  get_research_brief: "Getting research brief",
  get_brand_dna: "Loading brand DNA",
  ads_plan_ugc_elements: "Planning UGC reference elements",
  ads_generate_ugc_element_refs: "Creating UGC reference shots",
  ads_generate_ugc_avatars_from_brief: "Generating UGC avatars",
  ads_generate_images_from_research: "Generating images from research",
  ads_generate_videos_from_assets: "Generating videos from assets",
  ads_create_multi_shot_video: "Creating multi-shot video",
  ads_forecast_performance: "Forecasting ad performance",
  ads_open_forecast_modal: "Opening performance forecast",
  ads_open_new_ad: "Opening new ad",
  ads_ui_announce_plan: "Announcing plan",
  ads_ui_plan_advance: "Advancing plan step",
  ads_select_assets: "Selecting ad assets",
  ads_toggle_favorite: "Toggling favorite",
  get_video_project: "Inspecting video project",
  get_video_frames: "Inspecting video frames",
  get_video_visuals: "Inspecting video visuals",
  apply_video_edit_spec: "Applying video edit",
  upsert_video_overlays: "Updating video overlays",
  export_video: "Exporting video",
  video_editor_focus: "Focusing video editor",
  video_editor_playback: "Controlling video preview",
  video_editor_save: "Saving video project",
  video_editor_retrim_broll: "Trimming b-roll",
  video_editor_remove_broll: "Removing b-roll",
  video_editor_move_broll: "Moving b-roll",
  video_editor_set_clip_transition: "Setting clip transition",
  dispatch_video_editor_image_assets: "Generating editor image assets",
  dispatch_batch_images: "Generating image batch",
  dispatch_batch_videos: "Generating video batch",
  dispatch_ad_publishing: "Publishing ads",
  dispatch_gads_agent: "Running Agent G",
  check_ad_platform_status: "Checking ad platform status",
  heygen_create_video_agent_session: "Starting Agent V render",
  heygen_send_video_agent_message: "Updating Agent V render",
  heygen_get_video_agent_session: "Checking Agent V progress",
  heygen_get_video_agent_resource: "Inspecting render resource",
  heygen_list_video_agent_styles: "Loading video styles",
  heygen_list_video_agent_videos: "Checking final video",
  heygen_stop_video_agent_session: "Stopping Agent V render",

  // ── Managed Agent built-in tools ───────────────────────────────────────
  read: "Reading file",
  write: "Writing file",
  edit: "Editing file",
  glob: "Searching for files",
  grep: "Searching file contents",
  web_fetch: "Fetching webpage",
  web_search: "Searching the web",
  // bash — handled dynamically by getBashLabel below
};

function fallbackToolLabel(toolName: string): string {
  return toolName
    .replace(/[_-]+/g, " ")
    .trim()
    .replace(/\s+/g, " ")
    .replace(/^\w/, (c) => c.toUpperCase());
}

/**
 * Derive a user-friendly label for a `bash` tool call by inspecting the
 * command string. Falls back to "Running command" when nothing specific
 * matches.
 */
function getBashLabel(input: unknown): string {
  const command =
    typeof input === "string"
      ? input
      : input && typeof input === "object" && "command" in input
        ? String((input as Record<string, unknown>).command)
        : "";
  const cmd = command.toLowerCase();

  // JWT / auth signing
  if (cmd.includes("jwt") || cmd.includes("token") || cmd.includes("sign")) {
    return "Authenticating";
  }
  // Kling API submission (POST with task-related path)
  if (cmd.includes("curl") && cmd.includes("kling")) {
    if (cmd.includes("post") || cmd.includes("-x post") || cmd.includes("-d")) {
      return "Submitting video task";
    }
    return "Checking video status";
  }
  // Generic API calls
  if (cmd.includes("curl")) return "Making API request";
  // Package management
  if (cmd.includes("pip install") || cmd.includes("npm install")) {
    return "Installing packages";
  }
  // Script execution
  if (cmd.includes("python") || cmd.includes("node")) return "Running script";

  return "Running command";
}

export function getToolCallFriendlyName(
  toolName: string,
  input?: unknown,
): string {
  if (toolName === "bash") return getBashLabel(input);
  return TOOL_CALL_FRIENDLY_NAMES[toolName] ?? fallbackToolLabel(toolName);
}

// Tool calls that are mechanical infrastructure noise — the user doesn't care
// that Vid regenerated a Kling JWT before each poll. Suppressing these in the
// chat cleans up the transcript so the meaningful steps ("Submitting video
// task", "Checking video status", agent text) are what the eye lands on.
const SUPPRESSED_CUSTOM_TOOL_NAMES = new Set([
  "generate_kling_jwt",
  "get_kling_jwt",
  "sign_kling_jwt",
  "kling_jwt",
  "marcus_show_onboarding_step",
]);

export function shouldSuppressToolCall(
  toolName: string,
  input?: unknown,
): boolean {
  if (toolName === "bash") {
    return getBashLabel(input) === "Authenticating";
  }
  return SUPPRESSED_CUSTOM_TOOL_NAMES.has(toolName);
}
